/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {Injectable} from "@angular/core";
import {
  BusinessProfileResourceService, CompanyAddressResourceService,
  CompanyRegistrationResourceService,
  UserResourceService
} from "@well/resource-services";
import {BusinessProfileInfoVO, CompanyDetailsDtoModel} from "@well/domain";
import {map, Observable} from "rxjs";
import {JsonApiResource} from "@irian-ro/abstract-resource";
import {AddressDTO} from '@well/address-management-shell-api';
import { CompanyType } from '@well/common-libs/legal-entity-management/domain-model';

@Injectable({providedIn: 'root'})
export class SignupWizardFeatureService{

  constructor(private companyRegistrationResourceService: CompanyRegistrationResourceService,
              private userResourceService: UserResourceService,
              private businessProfileResourceService: BusinessProfileResourceService,
              private addressResourceService: CompanyAddressResourceService){}

  saveCompanyDetails(companyDetailsDto: CompanyDetailsDtoModel): Observable<any>{
    return this.companyRegistrationResourceService.save(companyDetailsDto);
  }

  updateCompanyDetails(companyDetailsDto: CompanyDetailsDtoModel): Observable<any>{
    return this.companyRegistrationResourceService.update(companyDetailsDto);
  }

  assignCurrentUserToCompanySuperUser(legalEntityUuid: string){
    return this.userResourceService.assignCurrentUserToCompanyAsSuperUser(legalEntityUuid);
  }

  assignCompanyTypeToValidLegalEntity(legalEntityUuid: string, companyType: CompanyType){
    return this.companyRegistrationResourceService.assignCompanyTypeToValidLegalEntity(legalEntityUuid, companyType);
  }

  getPublicBusinessProfileForLegalEntity(legalEntityUuid: string){
    return this.businessProfileResourceService.getPublicBusinessProfileInfoForOwner(legalEntityUuid).pipe(
      map((res: JsonApiResource<BusinessProfileInfoVO, any>) => res.data)
    );
  }

  saveAddress(addressDTO: AddressDTO): Observable<any>{
    return this.addressResourceService.save(addressDTO);
  }

  updateAddress(addressDTO: AddressDTO): Observable<any>{
    return this.addressResourceService.update(addressDTO);
  }

}
